export default __webpack_public_path__ + "static/media/Version (3) - Order of the Phoenix_13.93e907d1.jpg";